import { Component } from '@angular/core';

@Component({
  selector: 'lib-processing-spinner',
  templateUrl: './processing-spinner.component.html',
  styleUrls: ['./processing-spinner.component.scss'],
})
export class ProcessingSpinnerComponent {}
